<div class="modal-wrapper">
  <span class="close-modal fa fa-close" mat-dialog-close></span>

  <div class="modal-wrapper__content">
    <h2 style="color:red;">Cannot upload file. Size cannot be greater than {{appConfig.data.maxImageSize | convertBytes}}.</h2>
    <p>Follow the below steps to reduce your file size.</p>
    <p-tabView id="system-tabs">
      <p-tabPanel header="Windows">
        <ul>
          <li>Open your image in Microsoft photos <span class="photo-icon"><img src="assets/img/photo-icon.png" alt="photo"> Photos</span></li>
          <li>Click on "..." (See more actions) on the top right corner.</li>
          <li>Click on resize and choose the image size.</li>
          <li>Check here for more details: <a target="_blank" href="https://www.businessinsider.com/how-to-resize-an-image-on-windows">How to resize an image on a Windows 10 computer</a></li>
        </ul>
      </p-tabPanel>
      <p-tabPanel header="MacOS">
        <ul>
          <li>In the Preview app on your Mac, open the file you want to change.</li>
          <li>Choose Tools > Adjust Size ("Scale proportionally" and "Resample image" should be selected by default).</li>
          <li>Enter a smaller value in the Width or Height no smaller than 1500 pixels.</li>
          <li>The new file size is shown at the bottom (Max size is 20 MB).</li>
          <li>Check here for more details: <a target="_blank" href="https://support.apple.com/guide/preview/resize-rotate-or-flip-an-image-prvw2015/mac">
            Resize, rotate, or flip an image in Preview on Mac - Apple</a></li>
        </ul>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
